import { Report1919Container } from "../../../containers/borrowSystem/Report/Report1919Container";

export function Report1919Page() {
    return (
        <Report1919Container />
    )
}